/* eslint-disable max-len */
export default {
  header: {
    navigation: {
      home: 'Home',
      // distribution: 'Distribution',
      // distributionEvent: 'Distribution event',
      // whitepapers: 'Whitepapers',
      downloads: 'Téléchargements',
      twitter: 'Twitter',
      wallet: 'Wallet',
      explorer: 'Explorateur',
      ecosystem: 'Écosystème',
      skyminer: 'Skyminer',
      hardware: 'Hardware',
      blog: 'Blog',
      // buy: 'Buy Skycoin',
      telegram: 'Telegram',
      discord: 'Discord',
      getWallet: 'Acheter des Skycoin',
      jobs: 'Emplois',
      ecosystem_overview: 'Résumé',
      skywire: 'Skywire',
      skywallet: 'Skywallet',
      obelisk: 'Obelisk',
      fiber: 'Fiber',
      cx: 'CX',
      cxo: 'CXO',
      other: 'Autre',
      pressreleases: 'Press Releases',
      gallery: 'Galerie',
      events: 'Events',
      explorerApi: 'Explorer API',
      merchandise: 'Marchandises',
      hardwareStore: 'Quincaillerie',
      skywallethdk: 'Skywallet HDK',
      whitepaper: 'Whitepapers',
    },
  },
  footer: {
    rightsReserved: 'All rights reserved',
    getStarted: 'Commencer',
  },
  // footer: {
  //   bounty: 'Bounty Channel',
  //   getStarted: 'Get started',
  //   explore: 'Explore',
  //   community: 'Community',
  //   wallet: 'Get Wallet',
  //   buy: 'Buy Skycoin',
  //   infographics: 'Infographics',
  //   whitepapers: 'Whitepapers',
  //   blockchain: 'Blockchain Explorer',
  //   distribution: 'Distribution',
  //   blog: 'Blog',
  //   twitter: 'Twitter',
  //   reddit: 'Reddit',
  //   github: 'Github',
  //   telegram: 'Telegram',
  //   slack: 'Slack',
  //   roadmap: 'Roadmap',
  //   skyMessenger: 'Sky-Messenger',
  //   cxPlayground: 'CX Playground',
  //   team: 'Team',
  //   subscribe: 'Mailing List',
  //   market: 'Markets',
  //   jobs: 'Jobs',
  //   bitcoinTalk: 'Bitcointalk ANN',
  //   instagram: 'Instagram',
  //   facebook: 'Facebook',
  //   discord: 'Discord',
  //   youtube: 'Youtube',
  // },
  // buyBanner: {
  //   lead: 'Existing Skycoins are available separately on the following exchanges',
  // },
  // buy: {
  //   heading: 'Choose your preferred exchange to buy Skycoin',
  //   c2cx: 'Buy on C2CX',
  //   cryptopia: 'Buy on Cryptopia',
  //   distributionEvent: 'Distribution event',
  // },
  notFound: {
    404: '404',
    message: 'Whoops! Looks like you\'re lost </br> This page does not exist anymore or has been moved to a new URL',
    title: 'Page not found',
    heading: 'Page not found',
    home: 'Home page',
  },
  // architectureOverview: {
  //   title: 'Architecture overview',
  //   description: 'Architecture overview - components which make up the Skycoin ecosystem',
  //   heading: 'Architecture overview',
  // },
  getStarted: {
    heading: 'Commencez avec Skycoin',
    paragraph: 'True decentralization means no government can censor Skywire, no corporate interest can stop it.<br/><br/>The internet began as a community of people wanting to share information — the time has come to bring back that vision of the internet using a cryptocurrency that truly fulfills Satoshi’s vision of a decentralized cryptocurrency with Skycoin.</p>',
    buy: 'ACHETER DES SKYCOIN',
    wallet: 'PORTEFEUILLE',
  },
  newsletter: {
    heading: 'Inscrivez-vous pour recevoir des mises à jour',
    button: 'S\'INSCRIRE',
    input: 'Entrer votre Email',
    skyminerOption: 'I\'m Interested in a Skywire Miner',
  },
  markets: {
    title: 'Buy Skycoin',
    loading: 'Loading, please wait...',
    description: 'Buy Skycoin',
    disclaimer: 'Please note that sending funds to crypto wolf before hitting "Start Transaction" will lead to transaction failure. Moreover, sending a different amount from the one indicated will also lead to transaction failure. Make sure that you have calculated the miner\'s fee in order to send the exact amount indicated',
    data: 'Market Data',
    contact: 'To list Skycoin and put your exchange here email ',
    video: 'How To Buy Skycoin Direct From Skycoin.com',
  },
  home: {
    title: 'Skycoin - Decentralize the Web',
    description: 'Skycoin is a new blockchain-based mesh-internet.',
    banner: {
      heading: 'Check out the Skycoin hardware gallery',
      button: 'View photos',
    },
    bannerStore: {
      heading: 'Commandez un Skyminer aujourd\'hui!',
      button: 'Visit store',
    },
    hero: {
      heading: 'Qu\'est-ce que Skycoin?',
      slider: {
        revolutionary: {
          title: 'Skycoin est révolutionnaire',
          description: 'Un nouvel écosystème Web3 construit à partir de zero.',
        },
        obelisk: {
          title: 'Skycoin est Obelisk',
          description: 'Un nouveau protocole consensuel destiné à résoudre les problèmes d’inefficacité des systèmes PoS et PoW.',
        },
        cx: {
          title: 'Skycoin is CX',
          description: 'Un nouveau langage complet et puissant pour le développement de blockchain.',
        },
        skywire: {
          title: 'Skycoin est Skywire',
          description: 'Un protocole de réseau et Internet plus fort, plus rapide et plus sécurisé.',
        },
        fiber: {
          title: 'Skycoin est Fiber',
          description: 'Une plate-forme personnalisable, évolutive, offrant des vitesses et une sécurité comparables à celles de Visa."',
        },
      },
      buy: 'Acheter des Skycoin',
      // community: 'Community',
      // whitepapers: 'Whitepapers',
      wallet: {
        get: 'Telecharger le portefeuille',
        // blurb: 'Skycoin is driving the new internet revolution.',
      },
    },
    // nav: {
    //   architecture: 'Architecture Overview',
    //   whitepapers: 'Skycoin Consensus White Papers',
    //   blockchain: 'Skycoin Blockchain',
    //   cx: 'CX',
    //   cxo: 'CXO',
    //   skywire: 'Skywire',
    //   viscript: 'Viscript',
    //   cryptoSphere: 'CryptoSphere VPN',
    //   messenger: 'Sky-messenger',
    //   mobileWallet: 'Mobile Wallet',
    //   bbs: 'BBS',
    // },
    // distributionEvent: {
    //   heading: 'Distribution event',
    //   body: 'The Skycoin distribution event has started. 1% (1 million) of Skycoin will be sold at a fixed price of 0.002 BTC / SKY.',
    //   participate: 'Participate',
    // },
    // blog: {
    //   heading: 'Latest news from blog',
    // },
    // aboutSkywire: {
    //   heading: 'What is Skywire?',
    //   lead: 'Skywire is the new internet. An incentivized mesh network poised to become the privacy protocol of the future.',
    //   paragraph: 'Skywire’s goal is to make corporate internet service providers a thing of the past by giving the internet back to the people with its revolutionary privacy protocol. Peer-to-peer technology with a grassroots ethos, Skywire’s new networking protocol promotes net neutrality and sharing without blocking, slowdowns or censorship.',
    //   button: 'Read More about Skywire, Powered by Skycoin',
    // },
    // technology: {
    //   header: 'Skycoin Technology and Ecosystem:',
    // },
    about: {
      //   heading: 'What is Skycoin?',
      //   lead: 'A currency for digital bandwidth, backed by the new internet. Fast transactions, no transaction fees, Skycoin is a third-generation cryptocurrency supporting a new free and open internet.',
      //   paragraph: 'Skycoin is the cryptocurrency of Skywire. That means Skycoin has a practical application more than simply acting as another digital currency. The way Skycoin works is this: When you pass something along the Skywire network, you earn Skycoin. When you need to access the bandwidth yourself, pay via Skycoin. It only takes seconds to send and receive, with thousands of transactions per second.',
      obelisk: 'EN SAVOIR PLUS SUR OBELISK',
      //   speed: {
      //     heading: 'Speed',
      //     body: 'We built Skycoin to compete with credit cards and services like AliPay/Apple Pay. Transactions happen in seconds, not minutes.',
      //   },
      //   privacy: {
      //     heading: 'Privacy',
      //     body: 'Skycoin makes it impossible to trace transactions by mixing transactions from multiple wallets to increase privacy using the CoinJoin protocol. ',
      //   },
      //   security: {
      //     heading: 'Security',
      //     body: 'Skycoin is more secure because it does not rely upon the good will of miners, it cannot be 51% attacked.',
      //   },
      //   ecosystem: {
      //     heading: 'Ecosystem',
      //     body: 'We’re building an ecosystem of real world applications on top of Skycoin starting with messaging, social media, and VPN.',
      //   },
    },
    network: {
      label: 'Digging deeper',
      heading: 'Obelisk',
      subheading: 'L\'ALGORITHME DE CONSENSUS SKYCOIN',
      body: 'Chez Skycoin, nous voulons apporter aux utilisateurs ce qu\'ils ont demandé: un véritable réseau décentralisé sans autorité centrale. Pour accomplir cette tâche, nous sommes allés au-delà de PoW et PoS pour créer un tout nouvel algorithme décentralisé qui reconfigure le fonctionnement interne de la blockchain. Notre algorithme de consensus distribué, Obelisk, réussit à fournir un tel réseau.<br/><br/>Son consensus empêche le développement d’un pouvoir centralisé. Skycoin ne nécessite aucune exploitation minière, est à l\'abri de 51% des attaques et les transactions se font en quelques secondes. Les décisions sont prises par consensus de la communauté et non sur les souhaits de quelques parties prenantes majoritaires.</p>',
    },
    miner: {
      heading: 'Explorez Skyminer',
      subheading: 'Le Skyminer de Skycoin est méticuleusement conçu et configuré pour fournir un réseau de télécommunication extrêmement solide pour l\'infrastructure Skywire. Le matériel conçu sur mesure vise à fournir une sécurité, une efficacité et des performances maximales au réseau défini par logiciel. L\'architecture multi-cartes permet à chaque nœud de prendre en charge un service indépendant sur Skywire. En isolant les nœuds, chaque service peut fonctionner en toute sécurité indépendamment des attaques sur les services périphériques. Ces nœuds fournisseurs de services sont gérés par un routeur OpenWRT avec des règles strictes de transmission de paquets et de contrôle d\'accès pour une sécurité accrue. Les Skyminers sont rémunérés en Coin Hours pour la fourniture de services et la sécurité du réseau Skywire.',
      link: 'Become a node',
      more: 'EN APPRENDRE PLUS',
      morePhotos: 'VOIR PLUS DE PHOTOS',
      headingHardware: 'The Skycoin hardware suite continues to materialize',
    },
    press: {
      heading: 'Skycoin Picked As Top 5 Crypto Projects For 2018',
      subheading: 'Le projet n ° 1 à surveiller...',
      forbes: 'Skycoin aims to provide a “new internet” that is global, decentralized, and not controlled by any country, corporation, or government entity.  For privacy gurus or net neutrality enthusiasts, this is a project to stay on top of.',
      huffingtonPost: 'Net neutrality and consumer data privacy emerged as two key issues in tech in 2017. If you’re concerned about paying ridiculous fees to ISPs for unreliable coverage, having your data sold, or government monitoring and censorship - Skycoin provides hope. These are the core issues Skycoin is attempting to solve.',
    },
    ecosystem: {
      heading: 'Skycoin est la plateforme d\'applications Blockchain la plus avancée au monde',
      subheading: 'ÉCOSYSTÈME SKYCOIN',
      fiber: {
        title: 'Fiber',
        text: 'L\'architecture de blockchain parallèle infiniment évolutive et hautement personnalisable de la plateforme Skycoin.',
      },
      obelisk: {
        title: 'Obelisk',
        text: 'Le «web of trust», un nouveau type d\'algorithme de consensus résolvant les failles fondamentales avec PoW & PoS.',
      },
      skycoin: {
        title: 'Skycoin',
        text: 'La plateforme de crypto-monnaie la plus puissante et la plus complète jamais créée.',
      },
      coinHours: {
        title: 'Coin Hours',
        text: 'Accumulé en tenant des Skycoin, les Coin Hours constituent le mécanisme de paiement des services fournis sur la plateforme Skycoin.',
      },
      coinJoin: {
        title: 'Coin Join',
        text: 'Utilisation de la plateforme native pour Coin Join afin de fournir des transactions totalement privées et introuvables.',
      },
      skyledger: {
        title: 'Skyledger',
        text: 'Platform for launching your very own ICO on top of Fiber, our blockchain technology.',
      },
      skywire: {
        title: 'Skywire',
        text: 'Le nouveau réseau Internet décentralisé, un réseau maillé sans fil qui vous paye pour le supporter.',
      },
      skyminer: {
        title: 'Skyminer',
        text: 'La base pour un Internet décentralisé incassable. Faites-vous payer pour fournir de la bande passante, du stockage et de l\'énergie du processeur pendant votre sommeil.',
      },
      nodes: {
        title: 'Nœuds',
        text: 'Les éléments constitutifs du réseau Skywire, utilisables par tous pour assurer la décentralisation de l\'écosystème Skywire.',
      },
      cx: {
        title: 'CX',
        text: 'Un langage de programmation construit sur mesure, développé sur Golang. Conçu pour être facile à apprendre et rapide à mettre en œuvre.',
      },
      cxo: {
        title: 'CXO',
        text: 'Un service de stockage en nuage de personne à personne conçu pour servir le réseau distribué de Skywire.',
      },
      kittyCash: {
        title: 'KittyCash',
        text: 'L\'application la plus populaire actuellement construite sur Fiber. Kittycash est un écosystème de jeu complet, propulsé par les chats.',
      },
      skyVpn: {
        title: 'SDN',
        text: 'Cryptage privé virtuel de bout en bout intégré sur le réseau Skywire pour assurer la confidentialité des usager.',
      },
      skyMessenger: {
        title: 'SkyMessenger',
        text: 'Notre service de messagerie entièrement crypté, sans regards indiscrets ni mauvais acteurs.',
      },
      bbs: {
        title: 'BBS',
        text: 'Le cadre pour la création de services de réseau social distribués.',
      },
    },
    news: {
      heading: 'Nouvelles',
    },
    signup: {
      heading: 'Joignez-vous à notre newsletter Skyfleet et prenez de la hauteur avec Skycoin!',
      body: 'Restez au courant, recevez des mises à jour de la part de l\'équipe Skycoin en vous inscrivant à notre newsletter! Entrez votre adresse e-mail personnelle et préparez-vous au décollage aujourd\'hui.',
      button: 'Sign Up',
    },
    // roadmap: {
    //   heading: 'Roadmap',
    //   blurb: 'Visit GitHub to follow or contribute to Skycoin’s continued development and deployment. We will be opening bounties for bug fixes, design and development in the coming months.',
    //   roadmapLink: 'See the full roadmap',
    //   link: 'See our roadmap [pdf]',
    //   mobileLink: 'Skycoin Roadmap Mobile 2017',
    //   community: 'To keep up to date with Skycoin’s latest developments or to start contributing, join Skycoin on Telegram.',
    //   communityLink: 'Join the community',
    //   timeline: {
    //     network: {
    //       quarter: 'Q3',
    //       year: '2017',
    //       content: 'Launch of the first downloadable network node, users will be able to earn coins for powering the network.',
    //     },
    //     applications: {
    //       quarter: 'Q3',
    //       year: '2017',
    //       content: 'The launch of our first applications on the Skywire Network: a decentralised, Redditesque, social media platform and VPN service.',
    //     },
    //   },
    // },
  },
  // whitepapers: {
  //   title: 'Skycoin Consensus Whitepapers',
  //   description: 'Download whitepapers.',
  // },
  downloads: {
    title: 'Télécharger',
    description: 'Télécharger le Portefeuille Skycoin',
    wallet: {
      heading: 'Télécharger le Portefeuille Skycoin',
      headingDaemon: 'Download Skywallet Daemon',
      // lead: 'For simple use, download the Desktop wallet. For advanced use, or slow connections, the CLI wallet provides a UI that runs directly in your browser.',
      build: 'LA VERSION ACTUELLE EST {version}.',
      macos: 'MacOS',
      linux: 'Linux',
      windows: 'Windows',
      android: 'Android',
      ios: 'iOS',
      androidRecommended: 'Google Play Store',
      androidRecommendedComment: ' (recommended)',
      iosRecommended: 'Apple iOS App Store',
      iosRecommendedComment: ' (recommended)',
      androidAdvanced: 'APK',
      androidAdvancedComment: ' (advanced)',
      withElectron: 'Installer',
      withElectronComment: ' (recommended)',
      withoutElectron: 'Portable',
      withoutElectronComment: ' (advanced)',
      download: 'Télécharger',
      instructions: 'Instructions',
      signature: 'Signature',
      torrent: 'Torrent',
      linuxDaemon: 'Daemon',
      linuxDaemonComment: '  ',
      macsDaemon: 'Daemon',
      macsDaemonComment: '  ',
      windowsDaemon: 'Daemon',
      windowsDaemonComment: '  ',
    },
    whitepaper: {
      title: 'Whitepapers',
      description: 'Skycoin Consensus Whitepapers.',
    },
    bbs: {
      heading: 'Télécharger Skycoin BBS',
      lead: 'Skycoin BBS est un réseau social décentralisé de nouvelle génération construit à l\'aide de Fiber, la technologie blockchain de Skycoin.',
      githublink: 'Trouvez les derniers fichiers binaires sur Github.',
      thinclient: 'Accéder à un client léger BBS.',
    },
    whitepapers: {
      heading: 'Télécharger le livre blancs sur le consensus Skycoin',
      download: 'Télécharger',
      cryptocurrencyNetwork: '暗号化通貨ネットワーク分布式コンセンサスアルゴリズム白書',
      skyFramework: 'Sky: un cadre d\'opinion et un modèle de consensus sur le réseau P2P',
      skyHashConsensus: 'SkyHash: un cadre d\'opinion et un modèle de consensus sur le réseau P2P',
      skyHash: 'SkyHash: un modèle de hash d’opinions',
      sznajd2: 'Sznajd2: Modèle dynamique d\'opinion sensible à la communauté',
      distributedAlgorithm: 'Un algorithme de consensus distribué pour les réseaux de crypto-monnaie',
    },
    assets: {
      heading: 'Télécharger le guide de marque Skycoin',
      guidelines: 'Directives de marque Skycoin',
      logo: 'Logo Skycoin PNG',
      sch_logo: 'Coin Hours Logo',
      font: 'Skycoin Sans police',
      branding: 'Skycoin v1.6.1',
    },
    skywire: {
      heading: 'Skywire',
      installationGuide: 'Guide d\'installation Skywire v1.0',
      minerAssemblyManual: 'Skywire Miner Manuel d\'assemblage v2.3',
      minerAssemblyManualHiRes: 'Skywire Miner Manuel d\'assemblage v2.3 Hi-Res',
      skyminer: 'Skyminerマイニングマシン取付マニュアルv2.2',
    },
    roadmap: {
      heading: 'Roadmap',
    },
  },
  thankYou: {
    message: 'Thank you! Your response has been recorded.',
  },
  // infographics: {
  //   title: 'Infographics',
  //   description: 'Graphical overview',
  // },
  // distribution: {
  //   title: 'Skycoin distribution event',
  //   description: 'On {date}, 1% (1 million) of Skycoin will be sold at a fixed price of 0.002 BTC / SKY.',
  //   hero: {
  //     heading: 'Skycoin distribution event',
  //     preEvent: 'On {begin}, 1% (1 million) of Skycoin will be sold at a fixed price of 0.002 BTC / SKY (500 SKY / BTC). This distribution event will stop on {end} or when 1% (1 million) SKY sells out, whichever is sooner.<br /><br />Check back to <a href="/distribution">skycoin.com/distribution</a> to participate in the event.<br /><br /><em>This event was originally scheduled for July 24, 2017 but has been rescheduled to August 8, 2017 due to uncertainty in the Bitcoin network during this time period.</em>',
  //     postEvent: 'The Skycoin distribution event ended on {date}. Join the Skycoin community on Telegram to stay up to date on upcoming distribution events.',
  //     participate: 'Participate',
  //   },
  //   countdown: {
  //     preEvent: 'The distribution event will begin on <strong>{date}</strong> at noon GMT.',
  //     eventInProgress: 'The distribution event will end on <strong>{date}</strong> at noon GMT.',
  //     days: 'Days',
  //     hours: 'Hours',
  //     minutes: 'Minutes',
  //     seconds: 'Seconds',
  //   },
  // },
  // roadmapPage: {
  //   heading: 'Development roadmap',
  // },
  ecosystem: {
    title: 'Écosystème',
    description: 'Écosystème',
    heading: 'Écosystème',
    subheading: 'ARCHITECTURE DU NOUVEL INTERNET',
    skycoin: {
      heading: 'Skycoin',
      body: 'Skycoin a été créé pour répondre aux faiblesses de Bitcoin et Ethereum. Née par nécessité, aucune autre pièce ne correspond à la vision initiale de Satoshi d’une monnaie numérique totalement décentralisée.<br/><br/>Skycoin est exempte de centralisation et de manipulation grâce à son algorithme de consensus révolutionnaire Obelisk. Il intègre CX, un langage de programmation complet et structuré conçu de toutes pièces pour permettre à des centaines de milliers de développeurs de déployer facilement des applications dans la blockchain. Skycoin fonctionne comme une devise avec des transactions pratiquement gratuites, une confidentialité absolue bientôt mise en œuvre et des vitesses similaires à celles de Visa avec une valeur intrinsèque garantie par de la bande passante et du stockage non fondée sur des spéculations.<br/><br/>La détention de Skycoin génère des Coin Hours qui sont utilisées pour acheter des services sur le réseau Skywire et qui peuvent être échangées pour plus de Skycoin.</p>',
      btn: 'EN SAVOIR PLUS SUR CX',
    },
    skywire: {
      heading: 'Skywire',
      body: 'Skywire est rapide et ne souffre pas de la limitation et d’ autres interruptions de service que vous obtenez avec les grands FAI.<br/><br/>Skywire est privé. Cela signifie que vous ne pouvez pas être suivi pendant que vous naviguez. Au lieu de payer par mois pour être suivre par le FAI (qui vend ensuite vos données de navigation sans autorisation), la communauté Skywire disposera d\'un service Internet garantissant la confidentialité de ses données.<br/><br/>C\'est incité. Skywire deviendra un réseau maillé sans fil (WMN). Les utilisateurs peuvent gagner des Skycoin et des Coin Hours en exécutant des nœuds matériels qui fournissent à la fois de la bande passante et du stockage à l\'ensemble du réseau. Les utilisateurs peuvent ensuite utiliser les heures gagnées sur le contenu et d’autres ressources du réseau, à leur guise.<br/><br/>C\'est sécurisé. Skywire est créé par les utilisateurs pour les utilisateurs. Les utilisateurs dictent les décisions prises sur le réseau et celui-ci fonctionne sur un système de réseau de confiance où les nœuds malveillants peuvent être coupés du réseau principal Skywire via l\'accord collectif de la communauté. Ce modèle de consensus permet à Skywire d\'être à l\'abri des attaques, de l\'exploitation et de la manipulation.<br/><br/>À une époque où les grandes entreprises profitent systématiquement des consommateurs, le réseau Skywire de Skycoin est une bouffée d’air pur. Skywire redonne le pouvoir aux gens et crée ainsi un Internet plus fort, plus rapide et plus sécurisé.</p>',
      skywireBtn: 'EN SAVOIR PLUS SUR SKYWIRE',
      cxoBtn: 'EN SAVOIR PLUS SUR CXO',
    },
    obelisk: {
      heading: 'Obelisk',
      body: 'La décentralisation dans un monde centralisé<br/><br/>Obelisk a été créé à partir des faiblesses des algorithmes Proof of Work (PoW) et Proof of Stake (PoS). Obelisk ne peut jamais être centralisé par des pools miniers ni manipulé par des actionnaires, ce qui signifie qu\'il est réellement décentralisé. Obelisk répartit l’influence sur le réseau selon une architecture Web-of-trust. Au lieu de mineurs, le réseau se compose de nœuds. Chaque nœud dispose de sa propre blockchain personnelle qui empêche et met en quarantaine les éventuels mauvais acteurs. Ces nœuds sont nettement moins coûteux à produire, à acquérir et à exploiter que n’importe quel mineur traditionnel utilisé pour Bitcoin ou Ethereum. Obelisk a été conçu pour être une alternative à PoW évolutive, peu coûteuse en calcul et économique. Ces fonctionnalités permettent à l’algorithme de fonctionner de manière durable sur du matériel à budget limité, sans gaspillage d’électricité ni consommation de ressources naturelles précieuses. La centralisation devient quasi impossible quand pratiquement tout le monde est capable de faire fonctionner un nœud.</p>',
      btn: 'learn more about obelisk',
    },
    experiments: {
      heading: 'Fiber',
      body: 'L\'architecture de blockchain parallèle infiniment évolutive et hautement personnalisable de la plateforme Skycoin. Fiber est une solution meilleure que la blockchain, qui transforme la manière dont elle résout les problèmes existants avec la technologie de ledger distribué.<br/><br/>Fiber (la Fibre de Skycoin) est à la base de la «crypto-monnaie 3.0», un réseau infiniment évolutif de blockchain juxtaposées, comme des brins. Chaque projet hébergé sur Fibre possède son propre blockchain privé entièrement personnalisable, capable de vitesses similaires à celles de Visa. Chaque brin ajouté à Fibre renforce l\'ensemble du réseau et construit le tissu de l\'écosystème entier.<br/><br/>Skycoin Fiber does not compete with first and second generation cryptocurrency architectures, it replaces them. From fledgling blockchain projects to enterprises looking for solutions, Fiber is the answer.<br/><br/>Skycoin Fiber ne rivalise pas avec les architectures de crypto-monnaie de première et deuxième génération, il les remplace. Des projets novateurs à la blockchain aux entreprises, Fiber est la solution.</p>',
      btn: 'EN SAVOIR PLUS SUR FIBER',
    },
    iconLabel: {
      fiber: 'Fiber',
      coinHours: 'Coin Hours',
      cx: 'CX',
      obelisk: 'Obelisk',
      coinJoin: 'Coin Join',
      skyminer: 'Skyminer',
      node: 'Node',
      cxo: 'CXO',
      bbs: 'BBS',
      skyMessenger: 'SkyMessenger',
      skyVPN: 'SDN',
      kittyCash: 'KittyCash',
    },
    about: {
      heading: 'Qu\'est-ce que Skycoin?',
      paragraph1: 'Le but initial de la monnaie numérique était de réinventer l’économie afin de donner aux utilisateurs le pouvoir de commercer de manière indépendante, sans intervention des pouvoirs centralisés. Chez Skycoin, nous croyons fermement en cette mission. C’est la raison pour laquelle la blockchain Skycoin est conçue pour profiter à tous les utilisateurs, pas seulement à quelques privilégiés. Avec Obelisk, nous résolvons les problèmes inhérents aux pièces basées sur PoW et PoS pour vous offrir un réseau de consensus décentralisé et démocratique.',
      paragraph2: 'Satoshi a envisagé le Bitcoin comme une monnaie numérique décentralisée. Les réseaux de blockchain visaient à démocratiser la finance, en éliminant le contrôle des entreprises et en répartissant le pouvoir entre les utilisateurs. Toutefois, les bitcoins et les monnaies associées sont devenus centralisés en raison de leur utilisation des algorithmes de proof-of-work (PoW) et de proof of stake (PoS), ainsi que de leur utilisation par l’extraction pour créer des pièces. Cette centralisation va à l\'encontre de l\'objectif initial des monnaies numériques.',
      paragraph3: 'Nous avons créé la blockchain Skycoin pour corriger ces failles. La blockchain Skycoin utilise un nouvel algorithme de consensus pour remplacer PoW et PoS. Il corrige également les problèmes de sécurité associés aux autres réseaux de blockchain et dissocie la création de pièces du processus de minage. Le résultat est une crypto-monnaie entièrement décentralisée qui concrétise la vision initiale de Satoshi.',
      paragraph4: 'La blockchain Skycoin n\'utilise pas de minage, elle ne peut donc pas être concentrée dans quelques grands bassins miniers, comme c\'est le cas avec Bitcoin aujourd\'hui. La création de pièces ne donne pas à certains utilisateurs un contrôle disproportionné sur le réseau. L\'offre de Skycoin est fixe. Les transactions Skycoin s\'effectuent en quelques secondes et sont plus sécurisées. Avec Skycoin, nous avons créé une crypto-monnaie immuable qui fonctionne comme une propriété numérique, plutôt qu’un outil politique permettant de mieux contrôler les réseaux.',
    },
    roadmap: {
      dev: {
        heading: 'Route du développement de Skycoin',
      },
      marketing: {
        heading: 'Skycoin Marketing Roadmap',
      },
    },
  },
  skyminer: {
    title: 'Explore Skyminer',
    description: 'Skyminer: Matériel pour le nouvel Internet.',
    hero: {
      heading: 'Skyminer: <br/>Matériel pour le nouvel Internet.',
    },
    about: {
      heading: 'Explorez Skyminer',
      subheading: 'SKYWIRE MINER: MATÉRIEL POUR LE NOUVEL INTERNET',
      paragraph1: 'Le «mineur» de Skywire est méticuleusement conçu et configuré pour fournir la colonne vertébrale au nouvel Internet. Son matériel sur mesure dépasse les spécifications techniques pour offrir une puissance et des performances maximales. Skywire fonctionne comme un «mineur» pour Skycoins. Il agit en tant que VPN spécialisé, utilisant la configuration matérielle suivante:',
      paragraph2: 'Chaque carte est dotée d\'un processeur ARM, de 2 Go de RAM et d\'une mémoire flash de 16 à 256 Go. Le matériel est segmenté de telle sorte que même si un service est compromis, les autres services sur le même ordinateur ne peuvent pas l\'être. Un routeur OpenWRT avec des règles strictes de transmission de paquets et un contrôle d\'accès augmente la sécurité. La configuration peut être personnalisée pour se composer de 4, 8, 16 ou 32 cartes.',
      paragraph3: 'Les nœuds opérant sur le réseau Skywire recevront une prime d’intéressement du réseau pour aider à développer le réseau, en plus des paiements de transfert de trafic. Pour les mineurs de Skywire, nous souhaitons augmenter cette prime d’intéressement du réseau. Cependant, nous sommes toujours en train de mettre au point un mécanisme permettant de distinguer les mineurs de Skywire des autres nœuds, qui pourraient être n’importe quelle machine du réseau.',
      list: {
        item0: '8 cartes CPU',
        item1: '2 Go de RAM par carte',
        item2: '4 cœurs de processeur par carte',
        item3: '16 Go de stockage par carte',
        item4: 'Linux 64 bits (Debian)',
        item5: 'Ethernet Gigabit, commutateur à 8 + 1 ports',
      },
    },
    video: {
      heading1: 'Qu\'est-ce qu\'un Skyminer?',
      heading2: 'Présentation du Skyminer',
      heading3: 'Déballement du Skyminer',
      more: 'REGARDER PLUS DE VIDÉOS',
    },
    gallery: {
      heading: 'Galerie',
    },
    signup: {
      heading: 'Rejoignez la liste d\'attente Skyminer',
      body: 'Réservez votre place dans l\'internet de demain, aujourd\'hui!',
    },
  },
  roadmap: {
    title: 'Skycoin Roadmap',
    description: 'Skycoin Roadmap',
    heading: 'Skycoin Development Roadmap',
  },
  skywire: {
    title: 'Skywire',
    description: 'Skywire - The Foundation of a New Internet',
    about: {
      heading: 'Qu\'est-ce que Skywire?',
      subheading: 'LA FONDATION D\'UN NOUVEL INTERNET',
      quote: 'Tout le monde pourra contribuer et bénéficier de Skywire.',
      paragraph1: 'Skywire constitue la prochaine étape évolutive du développement et de l’utilisation de l’internet. Nous voulons sortir de l\'étouffement que les fournisseurs de services Internet (FAI) ont sur le marché en rendant le pouvoir à la population. Pour ce faire, nous fournissons un réseau maillé décentralisé entretenu par la communauté, où les utilisateurs eux-mêmes posséderont et contrôleront l’infrastructure du réseau. Notre objectif est de fournir à tous un accès à un Internet rapide, sécurisé, privé et fiable.',
      paragraph2: 'Il est temps de laisser les FAI comme un vestige du passé. Les clients font systématiquement suivre leurs données de navigation, les stockent et les vendent, tout en bénéficiant d’une couverture peu fiable et d’un service client de qualité médiocre. Au lieu de s\'appuyer sur des réseaux appartenant à l\'entreprise, le réseau maillé Skywire fonctionne sur de nombreux nœuds appartenant à des utilisateurs, qui s\'unissent pour fournir l\'infrastructure nécessaire au réseau, permettant ainsi aux communautés d\'alimenter leur accès Internet.',
    },
    features: {
      heading: 'Caractéristiques Clé:',
      speed: {
        title: 'VITESSE',
        text: 'Nous avons tous connu les connexions lentes, les pannes et la limitation qui vont de pair avec les FAI actuels. Le protocole de Skywire est basé sur un réseau défini par logiciel. Skywire prend en charge la liaison de canaux qui offre une vitesse et une fiabilité inégalées. La possibilité de se connecter à plusieurs nœuds à la fois augmente considérablement le débit et la redondance, démocratisant des cas d\'utilisation auparavant difficiles.',
      },
      privacy: {
        title: 'CONFIDENTIALITÉ',
        text: 'Avec le cryptage de bout-en-bout par défaut, Skywire garantit que tout le trafic est privé et que les utilisateurs n\'auront jamais leurs données suivies, stockées ou vendues. Les troisième parties ne seront pas en mesure de connecter des paquets individuels à un utilisateur ou à une adresse IP, et ils ne seront pas en mesure de lire le contenu du trafic réseau. Les nœuds de relais ne disposeront d\'informations de routage que pour un seul nœud antérieur et ultérieur pour le déplacement du paquet de données crypté. Les utilisateurs pourront enfin naviguer avec une réelle confidentialité.',
      },
      security: {
        title: 'SÉCURITÉ',
        text: 'Today, internet users have no say in how ISPs operate. Skywire gives this decision making power back to  the community in the form of a web-of-trust system. The consensus model allows nodes to be cut off if  deemed malicious, or strengthened if considered trustworthy through collective community agreement.  By making sure everyone has their say, Skywire becomes immune to exploitation, manipulation, and  attack, and safer for all.',
      },
      ecosystem: {
        title: 'ECOSYSTEME AUTONOME',
        text: 'Le cœur de Skywire sera la communauté elle-même. En fournissant des récompenses Skycoin et Coin Hour aux opérateurs de nœuds, nous offrons des incitations aux personnes qui souhaitent contribuer au réseau. À leur tour, elles auront des Coin Hours à utiliser pour les ressources et les applications du réseau. Plus le réseau est utilisé, plus il devient puissant, rapide et robuste, ce qui crée une économie en boucle fermée et autonome.',
      },
      internet: {
        title: 'LA FONDATION D\'UN NOUVEL INTERNET',
        text: 'Skywire pose les bases de la bande passante distribuée, du stockage et du calcul essentiels au nouvel Internet peer-to-peer. À l\'avenir, cette sainte trinité de produits numériques sera abordable et facilement accessible au monde via Skywire. Et dans un avenir pas si lointain, Skywire, combiné à l\'omniprésence de Skywire, fournira les nœuds nécessaires pour décentraliser efficacement le nombre illimité d\'applications blockchain qui fonctionneront sur l\'architecture Fiber de Skycoin.',
      },
    },
  },
  cxo: {
    title: 'CXO - CX Object Systems',
    description: 'CXO - CX Object Systems',
    about: {
      heading: 'Qu\'est-ce que CXO?',
      subheading: 'SYSTÈMES D\'OBJETS CX',
      quote: 'Skycoin construit un nouvel écosystème composé des éléments suivants:',
      paragraph1: 'CXO (CX Object Systems) est le système d’objet immuable de Skycoin, précédemment appelé Aether. Conçu pour remplacer les méthodes conventionnelles actuelles de partage informatique, CXO crée un système de stockage robuste qui remplace les services tels que BitTorrent, Dropbox et Google Drive. Les données sont répliquées entre noeuds à l\'aide de la bibliothèque Skycoin CXO.',
      paragraph2: 'CXO incorpore et étend les protocoles utilisés dans d\'autres réseaux de stockage basés sur la blockchain. CXO est un IPLD, avec un schéma intégré qui définit des contraintes pour classer les bases de données pouvant être liées. Les systèmes de fichiers interplanétaires (IPFS) peuvent être construits sur CXO. CXO assure la distribution des données sur le réseau Skywire et est utile pour les données qui doivent être sécurisées et vérifiables sans nécessiter de stockage dans la blockchain.',
      skywire: {
        title: 'Skywire',
        text: 'Skywire- Internet décentralisé soutenu par la communauté',
      },
      cx: {
        title: 'CX',
        text: 'Spécification et langage de programmation',
      },
      cxo: {
        title: 'CXO',
        text: 'Bibliothèque de bas niveau conçue pour héberger des applications pour le partage d\'objets',
      },
    },
    features: {
      heading: 'Key Features:',
      sharing: {
        title: 'Partage de données',
        text: 'Utile pour les propriétaires de données qui souhaitent partager leurs fichiers, tels que des clés publiques. Les noeuds CXO peuvent s\'abonner à un reseau pour recevoir les mises à jour et se connecter à l\'aide du serveur de découverte, en interconnectant les données en fonction des centres d\'intérêt.',
      },
      privacy: {
        title: 'CONFIDENTIALITÉ',
        text: 'Les données CXO existent collectivement sur le réseau. Une fois les données publiées, elles ne peuvent plus être détruites et la liste de données sont téléchargés à partir d\'abonnés homologues. Pour des raisons de confidentialité, l\'emplacement de l\'éditeur ne peut pas être suivi, car l\'éditeur devient simplement un nombre sur le réseau décentralisé.',
      },
      security: {
        title: 'SÉCURITÉ',
        text: 'CXO existe dans un écosystème autonome et mathématiquement strict. Les propriétaires signent des données à l\'aide de clés privées et les utilisateurs recevant les données peuvent auditer la signature à l\'aide de sources de clé publique pour s\'assurer que les données proviennent du propriétaire souhaité. La sécurité est assurée car les nœuds ne peuvent pas modifier les données sans utiliser les clés privées du propriétaire.',
      },
      apps: {
        title: 'APPLICATIONS DE CXO',
        text: 'Les applications sur CXO sont actuellement testées avec une utilisation légère. SkyBBS est un réseau social similaire à Facebook, Steemit et Twitter. Il est construit sur le CXO et de nombreux autres sont à venir.',
      },
    },
  },
  cx: {
    title: 'CX - CX programming language',
    description: 'CX - programming language',
    about: {
      heading: 'Qu\'est-ce que CX?',
      subheading: 'LANGAGE DE PROGRAMMATION',
      paragraph1: 'CX est la langue de programmation de Skycoin, riche en fonctionnalités. CX apporte de nombreux avantage dans le projet Skycoin. Elle permet la création d’accords contractuels complexes (les Smart Contracts) conçus sans souci de sécurité.',
      paragraph2: 'CX déploiera des obligations modifiables pour les projets construits sur la plateforme Skycoin. Ces attributs font tous partie du langage de programmation CX:',
    },
    features: {
      heading: 'Les caractéristiques de CX:',
      affordances: {
        title: 'AFFORDANCES',
        text: 'L\'utilisation des affordances permet d\'accorder ou de refuser l\'autorisation de paquets à des utilisateurs spécifiques, ce qui permet aux programmeurs de créer un code sécurisé en toute confiance. Le système d’ affordances peut être interrogé pour obtenir une liste d\'actions pouvant être placées sur des fonctions de program.',
      },
      programming: {
        title: 'PROGRAMMATION GÉNÉTIQUE (PG)',
        text: 'La programmation génétique est une évolution dans la création de programmes dans CX. En tant qu’outil d’apprentissage automatique, GP aidera les programmeurs en fournissant des moteurs de résolution automatique de problèmes et la possibilité d’ajuster les courbes et de créer des modèles prédictifs.',
      },
      deterministic: {
        title: 'LANGUE DETERMINISMINISTE',
        text: 'Le déterminisme permet de créer des programmes CX en toute confiance, évitant ainsi aux programmeurs de se préoccuper de la machine sous-jacente dans les environnements intégrés, car les output sont toujours produites indépendamment des machines.',
      },
      typing: {
        title: 'SYSTÈME DE TYPAGE STRICTE',
        text: 'Le système de typage strict de CX fournit une couche supplémentaire de redondance et de facilité d\'utilisation, rendant le processus de débogage simple. Cela réduit les erreurs et sécurise constitutionnellement CX pour les programmeurs.',
      },
      complied: {
        title: 'LANGUE COMPILÉE ET INTERPRÉTÉE',
        text: 'Fonctionnant à la fois comme une langue compilé et interprété. Cela donne aux programmeurs la possibilité d\'exploiter ses fonctionnalités avancées avec la fonction supplémentaire d\'être flexible et interactif.',
      },
      garbage: {
        title: 'RAMASSE-MIETTES',
        text: 'Une forme de gestion automatique de la mémoire, le ramasse-miettes CX récupère automatiquement les objets inutilisés dans la file d\'attente, libérant ainsi une mémoire précieuse pour les opérations nécessaires. CX trouve dans le programme des objets de données inaccessibles et les élimine.',
      },
      object: {
        title: 'L’EXPLORATEUR D\'OBJETS',
        text: 'Les programmeurs auront accès à un explorateur d\'objets qui affichera une vue graphique de tous les objets et leur allocation de mémoire actuelle. Ces objets peuvent être sérialisés et livrés, tandis que le code permettra aux programmeurs de reprendre l\'exécution de ces objets au dernier état observé.',
      },
    },
    roadmap: 'Feuille de route Skycoin',
  },
  jobs: {
    title: 'Skycoin is hiring developers.',
    subtitle: 'We are hiring',
    sidebarTitle1:
      'Apply for a job by sending an email to jobs@skycoin.com with the following information:',
    sidebarTitle2: 'with this information:',
    sidebarList: {
      item_1: 'Position desired',
      item_2: 'Name',
      item_3: 'Time zone',
      item_4: 'Full-time or part-time',
      item_5: 'Telegram username',
      item_6: 'Resume (PDF)',
    },
    ourProject:
      'All of our projects are developed in Go and C. For frontend work, we use ',
    angular: 'Angular',
    or: ' or ',
    react: 'React.js.',
    ourTeam:
      'Our team is spread across the world and you will be working either remotely or at one of our offices in Shanghai. We communicate using',
    accordion1: {
      title: 'Technical Writer',
      responsibilities: {
        title: 'Responsibilities',
        item1:
          'Work on a remote team to create articles to communicate technical progress to readers',
        item2: 'Create and update technical documentation',
        item3: 'Create user manuals for various Skycoin projects',
      },
      requirements: {
        title: 'Requirements',
        item1:
          'Excellent English reading and writing skills as well as previous experience with technical writing.',
        item2:
          'Knowledge of concepts and technologies used in the software development process.',
      },
    },
    accordion2: {
      title: 'Software Engineer (Backend)',
      description:
        'Work on a fully remote team developing blockchain-, networking- and infrastructure-related software. Experience writing in Go (Golang) required.',
      projects: {
        title: 'A Sample of Active Projects',
      },
    },
    accordion3: {
      title: 'Firmware Engineer',
      description:
        'Work on a fully remote team developing firmware and embedded software for various hardware projects.',
      projects: {
        title: 'A Sample of Active Projects',
      },
    },
    accordion4: {
      title: 'Circuit Engineer',
      description:
        'Study relevant technical materials to compile the proper English materials for foreign members making up 80% of total team members. Good proficiency in English reading and writing is a requirement for admission.',
      responsibilities: {
        title: 'Responsibilities',
        item1:
          'Draw PCB Design drawing and circuit schematic diagram according to product requirements;',
        item2:
          'Edit the instruction documents for production, such as BOM format and screen mesh;',
        item3:
          'Carry out the selection of components and be in tune with suppliers on product supply;',
        item4: 'Carry out type testing and reliability testing;',
        item5: 'Write technical documents and file them.',
      },
      requirements: {
        title: 'Requirements',
        item1:
          "Hold a bachelor's degree or above in electronic engineering or related discipline;",
        item2:
          'Possess very strong English reading and writing skill in response to the search and quick study of technical materials and the daily conversation in an English-speaking environment;',
        item3:
          'Process the ability to proficiently design analog circuits and digital circuits, and read and draw schematic diagram skillfully;',
        item4:
          'Use Altium Designer or other same type software skillfully in response to the independent conduct for layout design of four-layer PCB board.',
        item5:
          'Possess the strong ability to circuit adjustment and test, and use common instruments skillfully;',
        item6:
          'Have a certain understanding of the model and supply chain of ordinary electronic components;',
        item7:
          'Think clearly, take initiative in working process, hold the ability in both strong executive and excellent self-study, and maintain good teamwork spirit.',
      },
      priority: {
        title:
          'High-priority candidates include those with any of the following conditions',
        item1:
          'Possess the ability to be familiar with English materials on Electronics Industry or the English-speaking proficiency;',
        item2:
          'Enable to use SolidWorks and other same types of 3D modeling software and to read mechanical drawings;',
        item3:
          'Have experience in the development of mechanical control programs, Raspberry Pi or Arduino;',
        item4:
          'Have knowledge or experience in any one of the following three sectors--- the Internet of things, communication, and integrated circuits;',
        item5: 'Understand the knowledge of blockchain well;',
      },
      program: {
        title: 'Internship Program',
        item1:
          'Submit at least one work about PCB Design, and relevant cites must be marked if any;',
        item2:
          'Welcome to all of outstanding undergraduates and fresh graduates to take part in internship plan. Upon completion of the internship period, satisfactory trainees shall be given permanent posts.',
      },
    },
    accordion5: {
      title: 'Mechanical Engineer',
      description: 'Description',
      study:
        'Study relevant technical materials to compile the proper English materials for foreign members making up 80% of total team members. Good proficiency in English reading and writing is a requirement for admission',
      responsibilities: {
        title: 'Responsibilities',
        item1:
          'Engage in design, study and optimization for the structure of mechanical products, creation of products, and improvement of product performance and quality;',
        item2:
          'Choose component, set up model machine, test product, and provide technical support for subsequent development work;',
        item3:
          'Solve problems during product development work and meet new requirement from users;',
        item4:
          'Provide the volume production of products with relevant technical data;',
        item5:
          'Play an active role in other aspects of company business needs.',
      },
      requirements: {
        title: 'Requirements',
        item1:
          "Hold a bachelor's degree or above in mechanical engineering or related discipline;",
        item2:
          'Possess very strong English reading and writing skill in response to the search and quick study of technical materials and the daily conversation in an English-speaking environment;',
        item3:
          'Use SolidWorks or related software proficiently in response to the independent conduct for establishment, modification and derivation of model. Experience in designing and managing model documents with components whose total volume is more than 100 are preferred;',
        item4:
          'Understand the supply chain of ordinary mechanical components well;',
        item5:
          'Think clearly, take initiative in working process with the ability in both strong executive and excellent self-study, and maintain good teamwork spirit.',
        item6: 'Must be on site in Shanghai.',
      },
      priority: {
        title:
          'High-priority candidates include those with any of the following conditions',
        item1:
          'Possess the ability to be familiar with English materials on machinery industry or English-speaking proficiency;',
        item2:
          'Understand circuit knowledge and use Altium proficiently for completing the PCB Design;',
        item3:
          'Have experience in the development of mechanical control programs, Raspberry Pi or Arduino;',
        item4: 'Understand the knowledge of blockchain well;',
      },
      propgram: {
        title: 'Internship Program',
        item1:
          'Submit at least one model completed by using Solidworks, and relevant cites must be marked if any;',
        item2:
          'Welcome to all of outstanding undergraduates and fresh graduates to take part in internship plan. Upon completion of the internship period, satisfactory trainees shall be given permanent posts.',
      },
    },
    accordion6: {
      title: 'Industrial Designer OR Intern',
      description: 'Description',
      subtitle:
        'Study relevant technical materials to compile the proper English materials for foreign members making up 80% of total team members. Good proficiency in English is a requirement for admission',
      responsibilities: {
        title: 'Responsibilities',
        item1: 'New product exterior design and 3D modeling;',
        item2:
          'Choose component, set up model machine, test product, and provide technical support for subsequent development work;',
        item3:
          'Provide the volume production of products with relevant technical data;',
        item4:
          'Play an active role in other aspects of company business needs.',
      },
      requirements: {
        title: 'Requirements',
        item1:
          "Hold a bachelor's degree or above in product design or related discipline;",
        item2: 'Have had one-year experience working in relevant sector;',
        item3: 'Have fluent English speaking, reading and writing;',
        item4:
          'Use SolidWorks or relevant 3D modeling software skillfully in response to the independent conduct for establishment, modification and derivation of model.',
        item5:
          'Possess the ability to be familiar with processing technology of common materials, and have a certain understanding of the supply chain for relevant parts;',
        item6:
          'Possess the ability to outstanding aesthetic judgment and creative thinking skill, take initiative in working process, good cooperation spirit and will of study. ',
        item7: 'Must be on site in Shanghai.',
      },
      priority: {
        title:
          'High-priority candidates include those with any of the following conditions',
        item1:
          'Possess the ability to read mechanical drawings or electrical drawings;',
        item2:
          'Use Adobe Illustrator or other same type graphic design software proficiently;',
        item3: 'Understand the knowledge of blockchain well;',
      },
      program: {
        title: 'Internship Program',
        item1:
          'Submit at least one design work completed independently and its introduction;',
        item2:
          'Welcome to all of outstanding undergraduates and fresh graduates to take part in internship plan. Upon completion of the internship period, satisfactory trainees shall be given permanent posts.',
      },
    },
    accordion7: {
      title: 'Blockchain Internship Engineer',
      description:
        'Carry out 90% of the tasks in English and work together with English-speaking members making up 80% of total team members. Good communication skills and proficiency in English are requirements for admission; experiences in large international companies are preferred. Upon completion of the internship period, satisfactory trainees shall be given permanent posts.',
      responsibilities: {
        title: 'Responsibilities',
        item1:
          'Study the principle of blockchain, operation mechanism and relevant algorithms;',
        item2:
          'Take part in the design, development and testing of blockchain products;',
        item3:
          'Solve problems during development and testing, and provide technical support for products;',
        item4: 'Write technical documents and file them.',
      },
      requirements: {
        title: 'Requirements',
        item1:
          'Undergraduates and fresh graduates majoring in computer science, software engineering, or related specialists;',
        item2:
          'Process the outstanding ability to excellent communication skills and good English reading and writing skills, and to learn code and relevant technical materials well;',
        item3:
          'Be passionate about the programming, be fond of studying technique, and be strongly interested in the blockchain technology;',
        item4:
          'Be proficient in at least one of the following sectors--- C/ C++, JAVA, GoLang, and Swift Programming Language development, and have good habits of programming and proficiency in file compilation;',
        item5: 'Have experience in developing Linux platform;',
        item6:
          'Master the technique in data structure and algorithm, and be familiar with network protocols such as TCP/IP, HTTP and P2P;',
        item7:
          'Think clearly, take initiative in working process, hold the ability in excellent self-study, and maintain good teamwork spirit.',
        item8:
          'Submit your GitHub account and at least one work, and relevant cites must be marked if any;',
      },
      priority: {
        title:
          'High-priority candidates include those with any of the following conditions',
        item1:
          'Possess the ability to be familiar with relevant professional English vocabularies, and to communicate and express English freely;',
        item2:
          'Have experience in research, development and practitioner of the projects related to blockchain;',
        item3:
          'Have experience in the network protocol development, such as DNP, P2P, etc. ',
      },
    },
    accordion8: {
      title: 'Operations Manager',
      description:
        'This is a flexible position. The operations manager will be responsible for improving internal business processes and leading teams for various business goals as needed. Strong communication and organizational skills are required. Work position is remote or on-site in Shanghai.',
    },
    accordion9: {
      title: 'Marketing Manager',
      responsibilities: {
        title: 'Responsibilities',
        item1:
          'Build, optimize and scale effective marketing campaigns to drive growth across digital marketing channels',
        item2:
          'Identify and test new innovative growth opportunities to deliver on goals',
        item3: 'Collaborate with internal teams / vendors',
        item4: 'Manage performance metrics and budget tracking',
        item5:
          'Generate and create data driven hypotheses to execute experiments across the marketing funnel to optimize conversion and other key performance metrics',
        item6:
          'Execute global marketing strategies with integrated campaigns focusing on user acquisition and brand awareness',
        item7:
          'Coordinate with content writers and social media manager to ensure message consistency across various channels',
        item8:
          'Tell stories with data, transforming it into insightful and easy to interpret visuals',
        item9: 'Maintain brand voice, design and messaging',
        item10:
          'Work closely with the Product and Engineering teams to launch features and products',
      },
    },
    accordion10: {
      title: 'Social Media Manager',
      responsibilities: {
        title: 'Responsibilities',
        item1: 'Represent our brand on social media channels',
        item2:
          'Deliver engaging and inspiring messages to our social audiences, with the goal of driving brand awareness and consideration',
        item3: 'Significantly grow our audience on social media',
        item4: 'Define and implement paid and organic growth strategies',
        item5:
          'Turn our high level marketing strategy into a social media strategy and calendar',
        item6: 'Prioritize between channels, posts and messages',
        item7:
          'Work together with influencers, internal, and external teams to build social content that engages and inspires large customer audiences',
        item8: 'Scale our social content across multiple markets and languages',
        item9: 'Drive engagement with our social community',
        item10:
          'Ensure communication excellence and convert audience feedback into reputation/brand-building moments',
        item11:
          'Drive and develop customer understanding through insightful analyses and actionable reporting',
        item12:
          'Work closely together with the marketing manager to drive a consistent and differentiated brand message to a mix of countries and audiences',
      },
    },
    accordion11: {
      title: 'Content Writer',
      requirements: {
        title: 'Requirements',
        item1: 'Strong knowledge in various media and marketing channels',
        item2: 'Must be able to write content that is SEO friendly',
        item3:
          'Candidate needs to be self-motivated, detail-oriented, problem solving and able to work as a team with staff and administrators; have excellent communication and organization skills',
        item4: 'Must have a popular blogging experience',
        item5: 'Highly proficient in Cryptocurrency and blockchain technology',
        item6: 'Adobe Photoshop basic skills',
        item7: 'Creative thinking skills',
        item8:
          'Strong proficiency in the English language and excellent writing skills',
        item9:
          'Ability to translate complex technical concepts into easily comprehensible articles',
        item10: 'Excellent writing, analysis, and research skills',
      },
    },
    accordion12: {
      title: 'SEO Engineer',
      description:
        'The SEO Engineer will devise and implement SEO strategies on our website properties and in external SEO campaigns.',
    },
  },
  whitelist: {
    heading: 'Skywire Reward Application Form',
    signUp: {
      title: 'Connectez-vous, rejoignez Skywire et soyez récompensé!',
    },
  },
  fiber: {
    title: 'Fiber',
    description: 'Fiber is Blockchain 3.0 Innovation with Advanced Peer-Chain Architecture',
    about: {
      heading: 'Qu\'est-ce que la fiber?',
      subheading: 'INNOVATION BLOCKCHAIN V3.0 AVEC ARCHITECTURE AVANCÉE',
      quote: '« L’architecture Fiber de Skycoin est une solution transformationnelle, meilleure que la plupart des structure blockchain, qui résout les problèmes existants en utilisant la technologie de ledger distribué. Fiber est une Blockchain de 3ème génération et peut être décrite comme un réseau infiniment évolutif de blockchains juxtaposés, comme des brins. C’est un exploit technologique que des crypto-monnaies telles que Bitcoin ou Ethereum ne pourront jamais réaliser, car elles n’ont jamais été conçues à l’échelle infinie. »',
      author: 'Medium',
      paragraph1: 'Fiber est la couche structurelle de la plateforme blockchain de Skycoin, conçue sur mesure pour pouvoir être adaptée aux besoins de toute application blockchain. Fonctionnant sur un code innovant et extrêmement efficace, Fiber permet à la plateforme Skycoin de s’intégrer et de perturber véritablement tous les secteurs avec des solutions blockchain.',
      paragraph2: 'Fiber est aussi sophistiquée qu\'élégante, capable de s\'étendre et de s\'adapter aux besoins de nombreux types d\'applications distribuées.',
    },
    features: {
      heading: 'Les avantages de Fiber',
      system: {
        title: 'SYSTÈME DE BLOCKCHAIN SYMBIOTIQUE',
        text: 'L’architecture Fiber de Skycoin permet d’évoluer la plateforme Skycoin latéralement et verticalement sans compromettre les dépendances ni les défaillances réseau à l’échelle. Grâce au mécanisme de consensus <a href="https://medium.com/skycoin/skycoin-obelisk-8cc32bc9ca37" target="_blank" rel="noopener noreferrer">Obelisk</a>, chaque crypto-monnaie créée par Fiber sera fondamentalement isolé des autres, de sorte qu’il n’aura aucun impact sur la stabilité, la sécurité du réseau. De plus, grâce au système Skycoin <a href="https://medium.com/skycoin/skycoin-coin-hours-f537fa7ae614" target="_blank" rel="noopener noreferrer">Coin Hour</a>, chaque projet utilisant Fiber fera progresser la totalité de la plateforme Skycoin, sans entraver les opérations existantes. La Fiber crée un niveau sans précédent de symbiose entre les projets.',
      },
      forking: {
        title: 'FORKING FAIT DROIT',
        text: 'Les coins exécutés sur Fiber serront des forks du code principal de Skycoin, ce qui signifie que chaque projet aura le même niveau de fonctionnalités avancées de sécurité que Skycoin.',
      },
      blockchain: {
        title: 'BLOCKCHAIN PERSONNALISÉ',
        text: 'Les projets exécutés sur Fiber disposeront de leur propre blockchain, totalement indépendante et hautement personnalisable, pour répondre à leurs besoins spécifiques. Il est fondamentalement naïf de supposer qu\'un seul ensemble de règles ou d\'opérations répondra aux exigences d\'un large éventail de projets, ce qui signifie que l\'adaptabilité est le facteur le plus crucial d\'une plate-forme blockchain qui vise à évoluer verticalement et latéralement.',
      },
      token: {
        title: 'SOUTIEN DE PROJECT',
        text: 'Les project construits sur l\'architecture Fiber de Skycoin bénéficieront d’un niveau de soutien sans précédent. Les applications pourront fonctionner sur notre réseau révolutionnaire, Skywire, et chaque applications disposera d\'un support immédiat et d\'un support d\'échange dans l\'écosystème Skycoin.',
      },
      operation: {
        title: 'OPÉRATION INDÉPENDANTE',
        text: 'Au fur et à mesure que Skywire se transformera en un réseau maillé mondial, les crypto-monnaie sur Fiber fonctionnant sur Skywire seront indépendants à l\'infrastructure de réseau traditionnelle telle que les fournisseurs de services Internet. Cette indépendance de la plate-forme est unique à Fiber de Skycoin et à ses applications et projets distribués.',
      },
    },
  },
  skyminerForm: {
    title: 'Skyminer Order Information',
  },
  obelisk: {
    title: 'Obelisk',
    description: 'Obelisk - The Revolutionary Skycoin Consensus Algorithm',
    about: {
      heading: 'Qu\'est-ce que Obelisk?',
      subheading: 'L\'ALGORITHME RÉVOLUTIONNAIRE DE CONSENSUS SKYCOIN',
      quote: '"Les problèmes de centralisation, les attaques à 51%, les problèmes d’exploitation minière, la lenteur des transactions et le gaspillage d’énergie ne sont que quelques-uns des inconvénients majeurs des anciens algorithmes de consensus. Pour remédier à cela, Skycoin a développé Obelisk, le nouvel algorithme de consensus distribué qui résout les problèmes des générations précédentes et les rend obsolètes."',
      author: 'Medium.com',
      paragraph1: 'Obelisk est un algorithme de consensus révolutionnaire basé sur un réseau de confiance, conçu pour éliminer les problèmes introduits par les générations de consensus précédentes dans l’espace de la blockchain. L’architecture Web-of-trust crée un système parfait d’équilibres, permettant à la communauté et aux autres nœuds d’auditer le comportement du réseau avec un degré élevé de précision.',
      paragraph2: 'Avec la possibilité de couper les nœuds suspects pour comportement malveillant, le réseau devient plus fort. La mise en quarantaine des noeuds permet de gérer la confiance et, simultanément, ce processus permet à la communauté de rééquilibrer le pouvoir sur le réseau.',
    },
    features: {
      heading: 'Les Caractéristiques d’Obelisk',
      consumption: {
        title: 'CONSOMMATION D\'ENERGIE FAIBLE ET TRES SCALABLE',
        text: 'L\'algorithme de consensus a été conçu pour être évolutive et peu coûteuse en termes de validation des travaux, permettant à la fois à l\'algorithme et à la fabrication de blocs de fonctionner sur du matériel à source ouverte et à budget réduit.',
      },
      attack: {
        title: 'Resistant aux attaques à 51%',
        text: 'Un consensus sur le « Web-of-Trust » empêche le développement d’un pouvoir centralisé. Skycoin ne repose pas sur des incitations minières et n\'est donc pas exposé aux mêmes vulnérabilités present dans PoW et PoS',
      },
      defence: {
        title: 'DÉFENSE ROBUSTE',
        text: 'Obelisk peut résister à une attaque coordonnée à grande échelle par un réseau bien organisé de nœuds malveillants. L\'algorithme est non itératif, converge rapidement et peut s\'exécuter sur un nombre réduit de nœuds dotés d\'une connectivité voisine, comme sur un réseau maillé.',
      },
      structure: {
        title: 'STRUCTURE À DEUX NOEUDS',
        text: 'Un nœud de consensus reçoit son entrée d\'un ou de plusieurs nœuds générateurs de blocs. Les algorithmes sont séparés pour chacun, mais ils fonctionnent tous les deux sur les mêmes structures de données. Les deux types de nœuds effectuent toujours la vérification et la détection de fraude des données entrantes. Les messages frauduleux ou non valides sont détectés, supprimés et jamais propagés. Ainsi, les nœuds homologues engagés dans des activités suspectes seront coupés et leurs clés publiques interdites.',
      },
    },
  },
  gallery: {
    title: 'Gallery',
    description: 'Gallery',
    heading: 'Gallery',
    antennas: {
      heading: 'Biquad Yagi Antenna',
    },
    wallet: {
      heading: 'Skywallet',
    },
    skyminer: {
      heading: 'Skyminer',
    },
    diySkyminer: {
      heading: 'DIY Skyminers',
    },
  },
  landing: {
    skyware: {
      hero: {
        title: 'Skywire',
        heading: 'Skywire is the next evolutionary step in the internet’s development and use. Our goal is to provide everyone with access to fast, secure, private and reliable internet.',
        button: 'Learn more',
      },
      watchNow: {
        title: 'Watch now!',
        description: 'Check out these YouTube videos to learn more about Skywire',
        youtube: {
          what: 'What is Skywire?',
          solution: 'A Solution to Censorship',
          isp: 'Why ISPs need to be Replaced',
        },
      },
      afee: {
        text: '“To free Crypto from the bonds of corrupt power, we need more than distributed exchanges. We need to bypass the existing Internet. Mesh networks solve this problem. Skywire  is the only one designed by and for the Crypto Space.” ',
        name: 'John McAfee',
      },
      divider: 'Everyone will be able to contribute to and benefit from Skywire',
      bottom: {
        text: 'Its <b>private</b>, <b>secure</b> and <b>decentralized</b>. Join over 1,450+ nodes now on Skywire with our current special promotion!',
      },
      features: {
        speed: {
          title: 'VITESSE',
          description: 'Skywire’s protocol is based on software-defined networking, which will make the outdated and inefficient  “hot-potato” packet routing a thing of the past.',
        },
        privacy: {
          title: 'Privacy',
          description: 'With default end-to-end encryption, Skywire ensures that all traffic is private and users will never have  their data tracked, stored, or sold.',
        },
        security: {
          title: 'Security',
          description: 'Today, internet users have no say in how ISPs operate. Skywire gives this decision making power back to  the community in the form of a web-of-trust system.',
        },
        ecosystem: {
          title: 'Self-sustaining ecosystem',
          description: 'By providing Skycoin and Coin Hour rewards to  node operators, we offer incentives for people to contribute to the network.',
        },
        internet: {
          title: 'Foundation of the new internet',
          description: 'Skywire lays the foundation for distributed bandwidth, storage, and computation essential to the new  peer-to-peer internet',
        },
      },
    },
    skywallet: {
      hero: {
        title: 'Skywallet',
        heading: 'Your hardware multi-coin wallet is your bank vault and it should feel like a premium and secure device.  Shipping Q1 2019. Order now!',
        button: 'Order now',
      },
      features: {
        live: {
          title: 'Skywallet Live',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.',
        },
        security: {
          title: 'Security',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ',
        },
        support: {
          title: 'Customer support',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ',
        },
        intuitive: {
          title: 'Intuitive',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ',
        },
        included: {
          title: 'Included',
          description: 'TODO',
        },
      },
    },
    skyminer: {
      title: 'Skyminer',
      description: 'Skyminer',
      hero: {
        title: 'Skyminer',
        heading: 'The Skywire "miner" is meticulously designed and configured to provide a backbone for the new internet.',
        button: 'Learn more',
      },
      hardware: {
        title: 'Hardware',
        description: `
          <li>8 CPU boards</li>
          <li>2 GB of RAM per board</li>
          <li>4 CPU cores per board</li>
          <li>16 GB of storage per board</li>
          <li>64-bit Linux (Alpine Linux)</li>
          <li>100 Mbps Ethernet, 8+1 port switch</li>
        `,
      },
      operate: 'Operate your Skyminer on the Skywire network to <b>get paid</b> SKY for free!',
      watchNow: {
        title: 'Watch now!',
        description: 'Check out these YouTube videos to learn more about Skyminers',
        youtube: {
          video1: 'What is a Skyminer?',
          video2: 'Unboxing the Skyminer',
          video3: 'Introducing the Skyminer',
        },
      },
      support: {
        title: 'Excellent support',
        description: 'When purchasing a Skyminer you will get access to fast email support from our help desk ticket system.  Our Telegram community offers help as well with over 2000 members.',
      },
      orderNow: {
        text: `Its <b>private</b>, <b>secure</b> and <b>decentralized</b>. 
          Join over 1,450+ nodes now with our current special promotion!`,
      },
      forbes: {
        description: '“Skycoin aims to provide a new internet that is global, decentralized, and not controlled by any country, corporation or government. For privacy gurus or net neutrality enthusiasts… this is a project to stay on top of.”',
      },
    },
  },
  exchanges: {
    any: 'Any',
    title: 'Exchanges',
    description: 'Exchanges',
    exchanges: 'Exchanges',
    empty: ' ',
    lbank: 'LBank',
    c2cx: 'C2CX',
    bitbns: 'Bitbns',
    xbts: 'XBTS',
    coindcx: 'CoinDCX',
    table: {
      headers: {
        name: 'Name',
        link: 'Link',
        markets: 'Markets',
      },
    },
  },
  pressreleases: {
    any: 'Any',
    title: 'Press Releases',
    description: 'Press Releases',
    pressreleases: 'Press Releases',
    releases: {
      title: 'Skycoin Announces Public Release of Skywire Mainnet',
      description: 'Skycoin Announces Public Release of Skywire Mainnet',
      dates: 'March 20, 2019',
      content: {
        description: '<p>Skycoin has unveiled the developer version of their Skywire application. Developers will now be able to download, install, build, and run the Skywire mainnet utilizing a command line interface. Full developer documentation will be released over the next few weeks.</p><p><strong>SHANGHAI, March 19, 2019 /PRNewswire/ </strong>-- Work on Skycoin began in 2011 with the merging of three separate projects that aimed to improve upon the design and implementation of Bitcoin. The Skycoin developers identified several major philosophical design issues that they saw as obstacles to global use of cryptocurrency as a censorship-resistant payment system.</p><p>Skywire, the decentralized internet protocol and mesh network, was created as a solution to answer many of these problems.</p><p><strong>Skywire Mainnet is here for Developers to Test</strong></p><p>After about ten months of intensive testing on a network of nearly 10,000 nodes spanning the globe, Skycoin is happy to announce that the developer version of Skywire&apos;s mainnet is now available to the public. Its official launch date was the 4th of March 2019.</p><p>This first iteration of Skywire&apos;s mainnet features entirely rewritten software from the ground up and is primarily focused on a platform for developers to start building the next generation of distributed apps. All existing apps have been rewritten and optimized for the mainnet including a distributed and secure chat app, SSH, and a multi-hop tunneling proxy app. Many more will be coming soon.</p><p> <a href="https://www.blog.skycoin.com/posts/skywire-mainnet-public-testing-announcement/" rel="noopener noreferrer" target="_blank">This first version of Skywire&apos;s mainnet represents a huge milestone for Skycoin and for the future of the internet.</a> Skywire will serve as an unstoppable, highly resilient network, removing any possibility of censorship. </p><p>Skywire mainnet&apos;s developer build is the first release of many. Over the course of the next few months, Skycoin will be releasing new iterations and features for Skywire – one of these is an updater that allows Skycoin to push new features constantly – stay tuned for additional information, technical details, and further updates from the team.</p><p> <a href="https://github.com/skycoin/skywire/tree/mainnet" rel="noopener noreferrer" target="_blank">Skywire Mainnet on Github</a> </p><p>Please note: Do not install this on your skyminers as they are running testnet and will stop receiving rewards. Skywire mainnet can be installed on any other device to run, test and develop.</p><p>Bug reporting should be done through the repo, with steps taken to reproduce any feedback. Details of the process will be available in the readme section of the branch.</p><p><strong>What&apos;s Next for Skywire?</strong></p><ul> <li>A new and intuitive UI for developers and users to easily interact with the mainnet</li><li>Bandwidth monetization will be coming soon that will allow users to earn Coin Hours through bandwidth sharing</li><li>Coin Hours bank</li><li>Private Skycoin transactions utilizing CoinJoin</li><li>Remote management of unlimited nodes</li><li>Combining the CXO protocol with Skywire for distributed data storage</li></ul> <p><strong>About Skycoin</strong></p><p>Skycoin is a third generation blockchain company that has its own chain, consensus algorithm, programming language, hardware, and their flagship product Skywire which is a decentralized community-driven mesh network where users themselves will own and control the network&apos;s infrastructure. Skywire&apos;s goal is to provide everyone with access to fast, secure, private and reliable internet.</p>',
      },
    },
    releases_part: {
      title: 'Early Bitcoin and Ethereum Developers Set to Roll-Out "Skywire" - a New, Decentralized Internet from Skycoin',
      description: 'Early Bitcoin and Ethereum Developers Set to Roll-Out "Skywire" - a New, Decentralized Internet from Skycoin',
      dates: 'August 23, 2019',
      content: {
        description: '<p>Skywire is Designed to Eliminate the Privacy and Security Issues Found on the Internet</p><p><strong>SHANGHAI, CHINA / ACCESSWIRE / August 23, 2019 /&nbsp;</strong>After nearly a decade of development, the team behind the third-generation cryptocurrency Skycoin are ready to unveil their groundbreaking flagship project: a new, decentralized Internet called Skywire. Built from the ground up using cutting-edge new technology, Skywire was designed to completely eliminate the privacy and security deficiencies of the Internet as everyone knows it.</p><p>“Skycoin has created the foundation for a new decentralized Internet and the most advanced blockchain application platform in the world,” a spokesperson for Skycoin said, adding that over 10,000 hardware nodes have already been deployed for Skywire around the globe. These nodes, part of sophisticated custom hardware and software called Skyminers, form the backbone of this new Internet. More Skyminer nodes coming online means that the potential reach of Skywire is growing.Skywire is designed to be fundamentally faster than the current Internet, as well as much more secure with unprecedented privacy protection. “All traffic on Skywire is encrypted end-to-end,” said a spokesperson. “The technology we’ve developed makes tracking or spying on users literally impossible. The kinds of privacy violations we’ve seen from Facebook and Google simply couldn’t happen on Skywire.” That’s great news for the increasing number of Internet users who are uncomfortable with the invasive and obscure policies of social media companies, and wish to have greater control over who has access to their private data, and how it is used.</p><p>Skywire technology includes putting the hardware infrastructure for Skywire directly into the hands of its users, which will eventually eliminate the need for Internet Service Providers altogether. Operating a low-power Skyminer is as simple as plugging it into a home Internet router, which users are incentivized to do by earning cryptocurrency just for keeping nodes online. Skywire is designed to be hardware agnostic, meaning that people can buy Skyminers directly from Skycoin, or build their own using inexpensive materials available online. Running a Skyminer is an attractive investment for anyone who wishes to help build the Skywire infrastructure, but is not necessary in order to use the network.</p><p>“When Skyminers are attached to antennas, they can begin to link together into a wireless network that doesn’t require traditional Internet access in order to function, and can be accessed freely by any computer or device that can connect to a WiFi signal,” a spokesperson explained.</p><p>Users will not have to choose between two Internets; Skywire will allow access to the existing Internet for those who want the best of both worlds, though the ultimate in speed, privacy and security can only be found on Skywire.</p><p>The nature of Skywire’s decentralized and distributed infrastructure makes it considerably more robust than the current Internet, which has centralized access points through ISPs.</p><p>Skycoin will roll out a public mainnet for Skywire soon, which will mark the final phase in its launch. The first fully-functional large-scale mesh network running Skywire will debut in New York City before the end of the year, with other major cities around the world coming online in the near future as Skywire continues its ambitious worldwide roll-out.</p><p><strong>Interviews may be scheduled via email</strong>: <a href="mailto:drew@skycoin.com">drew@skycoin.com</a></p><p><strong>About Skycoin</strong></p><p>Skycoin is bringing people what they want: a truly decentralized network without any central authority. Founded in 2011 by early developers of Bitcoin and Ethereum, Skycoin quickly grew into an ecosystem of exciting and ambitious projects, including Skywire, the new decentralized Internet; CX, a revolutionary full-featured blockchain application programming language; and the cryptocurrency itself, Skycoin - simple to use, with virtually-free transactions that execute almost instantly. In 2020, Skycoin will release a superior “web-of-trust” blockchain consensus algorithm called Obelisk, which solves the problems inherent to “proof-of-work” and “proof-of-stake” protocols, both of which are slowing down and compromising the integrity of other major cryptocurrencies. For more background, please visit <a href="https://www.skycoin.com" rel="noopener noreferrer" target="_blank">https://www.skycoin.com</a></p><p><strong>Contact:</strong></p><p>Drew Macgibbon <br><a href="mailto:drew@skycoin.com">drew@skycoin.com</a></p><p><strong>SOURCE:</strong> Skycoin</p>',
      },
    },
    releases_october: {
      title: 'Skycoin Project Releases Hardware Development Kit (HDK) for New Cryptocurrency Wallet',
      description: 'Early Bitcoin and Ethereum Developers Set to Roll-Out "Skywire" - a New, Decentralized Internet from Skycoin',
      dates: 'August 23, 2019',
      content: {
        description: '<p>Skycoin is the first cryptocurrency to issue its own hardware wallet, along with a Hardware Development Kit to extend functionality</p><p>Shanghai, China / October 14th, 2019 / The Skycoin Project is pleased to announce the release of a Skywallet Hardware Development Kit (HDK) to anyone interested in extending the functionality of Skywallet, Skycoin’s sleek new hardware cryptocurrency wallet. The HDK is a developer-friendly version of the Skywallet, modified to facilitate programming and testing new code.</p><p>The Skywallet was made to support Skycoin (SKY) and Skycoin Coin Hours (SCH) out of the box, and a future firmware update will enable the Skywallet to hold additional major currencies, including Bitcoin, Ethereum, and more. But with thousands of cryptocurrency coins, tokens, and other assets available for trade, Skycoin wanted to ensure motivated developers had the opportunity to build support into Skywallet for their favourite cryptocurrency.</p><p>The support for additional cryptocurrencies may be accomplished using the HDK and then rolled out to Skywallet users in an optional firmware update, pending approval. The HDK may also be used to create applications that can run on Skywallet. For instance, if a developer wishes to use Skywallet as an authentication device, they could use the HDK to develop that functionality.</p><p>"We made Skywallet the most affordable hardware wallet on the market because we think crypto investors deserve the best security for their investment," said a spokesperson for the project. "We also know there are a lot of cryptocurrencies, and we wanted to give developers the chance to extend the power of Skywallet to their own favourite crypto coin or token."</p><p>The developer-friendly nature of Skywallet extends beyond the Hardware Development Kit to the firmware of the Skywallet itself, which is completely open-source. This means that the security of the Skywallet software may be verified by anyone who wishes to audit the code, because the complete codebase for the firmware is hosted in an open-source repository on <a href="https://github.com/skycoin/hardware-wallet" rel="noopener noreferrer" target="_blank">github</a>.</p><p>More exciting hardware projects from Skycoin, including Skywire antennas and the next generation of Skyminers, will be announced in the coming weeks and months.</p><p>The Skywallet Hardware Development Kit is available to order online at <a href="https://store.skycoin.com/" rel="noopener noreferrer" target="_blank">store.skycoin.com</a> beginning October 14, 2019.</p><p><strong>Media who wish to schedule interviews may reach out to:</strong> <br><strong>Drew MacGibbon</strong> <br><a href="mailto:drew@skycoin.com">drew@skycoin.com</a> <br>+15624529482</p><p> <br></p><hr><p> <br></p><p><strong>About Skycoin:</strong></p><p>Skycoin is bringing people what they want: a truly decentralized network without any central authority. Founded in 2011 by early developers of Bitcoin and Ethereum, Skycoin quickly grew into an ecosystem of exciting and ambitious projects, including <strong>Skywire</strong>, the new decentralized Internet; <strong>CX</strong>, a revolutionary fully-featured blockchain application programming language; and the cryptocurrency itself, <strong>Skycoin</strong> — simple to use, with virtually-free transactions that execute almost instantly.</p><p>In 2020, Skycoin will release a superior "web-of-trust" blockchain consensus algorithm called <strong>Obelisk</strong>, which solves the problems inherent to "proof-of-work" and "proof-of-stake" protocols, both of which are slowing down and compromising the integrity of other major cryptocurrencies.</p><p>For more background, please visit <a href="https://www.skycoin.com" rel="noopener noreferrer" target="_blank">https://www.skycoin.com</a></p>',
      },
    },
    releases_2019_10_17: {
      title: 'Secure and Private “New Internet” Skywire set to Launch in New York City',
      description: 'First Skywire NYC Meetup is a success',
      dates: 'October 17, 2019',
      content: {
        description: '<p><em>First Skywire NYC Meetup is a success</em></p><p><strong>New York City, New York / October 14th, 2019 /</strong> Skycoin held its first Skywire Mainnet Meetup in New York City on Thursday in anticipation of its forthcoming Skywire mesh network. The meeting took place at the NYC Blockchain Center, where Skycoin is a member, and was a great success. The meeting was also live-streamed via YouTube where dozens more watched it live, and several hundred tuned in to watch the final recording.</p><p>Skywire is the Skycoin Project’s new decentralized, private, and end-to-end encrypted internet. It is a mesh network comprised of small antennas attached to nodes called Skyminers. (Skyminers are powerful computers that provide the processing power, storage, and bandwidth for the network.)</p><p>The Skywire network in New York City is being built by members of the Skycoin community who believe in the principles of a free and open Internet, where privacy and security are foundational. Skywire puts the power is firmly in the hands of users, rather than Internet Service Providers, corporations, or advertisers. And unlike other attempts at creating community mesh nets, Skywire is incentivized. This means that Skycoin will pay node operators for their service to the network as a way to encourage growth and adoption of Skywire.</p><p>The ongoing rollout of the New York meshnet across Manhattan is a major milestone and proof-of-concept for the Skycoin Project, which has been working on the “new Internet” for nearly a decade.</p><p>Presenters at the meetup explained the technical details of the Skywire network to attendees, including multi-label packet switching (MPLS), public-key addressing, and software-defined networking, all of which make the Skywire network faster, safer, and more private than the current Internet. A number of antennas were shown as well, including long and short-range antennas. It is these antennas that will allow Skywire nodes to connect to one another across the city, and allow anyone within range to freely join the network.</p><p>The Skywire network will continue to be built over the coming months, growing stronger as more New Yorkers join the effort by deploying Skywire nodes of their own. The nodes themselves are easy to build using readily available parts, or may be purchased directly from skycoin.com.</p><p>Anyone interested in helping out should connect with the New York team via Telegram at t.me/SkycoinNewYork.</p><p><strong>Media who wish to schedule interviews may reach out to:</strong> <br><strong>Khalob Freeborn</strong> <br><a href="mailto:khalob@skycoin.comm">khalob@skycoin.com</a> <br>+14243542994</p><p> <br></p><hr><p> <br></p><p><strong>About Skycoin:</strong></p><p>Skycoin is bringing people what they want: a truly decentralized network without any central authority. Founded in 2011 by early developers of Bitcoin and Ethereum, Skycoin quickly grew into an ecosystem of exciting and ambitious projects, including <strong>Skywire</strong>, the new decentralized Internet; <strong>CX</strong>, a revolutionary fully-featured blockchain application programming language; and the cryptocurrency itself, <strong>Skycoin</strong> — simple to use, with virtually-free transactions that execute almost instantly.</p><p>In 2020, Skycoin will release a superior "web-of-trust" blockchain consensus algorithm called <strong>Obelisk</strong>, which solves the problems inherent to "proof-of-work" and "proof-of-stake" protocols, both of which are slowing down and compromising the integrity of other major cryptocurrencies.</p><p>For more background, please visit <a href="https://www.skycoin.com" rel="noopener noreferrer" target="_blank">https://www.skycoin.com</a></p>',
      },
    },
    releases_2019_11_26: {
      title: 'Skycoin Project Releases Affordable High-Security Hardware Wallet',
      description: 'Skycoin is the first cryptocurrency to issue its own hardware wallet.',
      dates: 'November 26, 2019',
      content: {
        description: '<p><em>Skycoin is the first cryptocurrency to issue its own hardware wallet.</em></p><p><em>Shanghai, China</em> — Skycoin is pleased to announce the immediate availability of <strong><em>Skywallet</em></strong>, a sleek and sophisticated cryptocurrency hardware wallet designed specifically with Skycoin in mind.</p><p>Skywallet was made to support Skycoin (SKY) and Skycoin Coin Hours (SCH) out of the box, and a future firmware update will enable the Skywallet to hold many different coins and tokens, including Bitcoin, Ethereum, and more. In addition, a Hardware Development Kit (HDK) is available to developers who wish to further extend the Skywallet’s functionality.</p><p>Skywallet is initially available in three different colors (black, white, and silver) for just $39.00 USD each. Despite the massive price drop relative to competition, no corners have been cut on ensuring that these devices are secure. In fact, the Skycoin team uncovered and resolved significant flaws in the firmware code of one of the most popular devices currently available.</p><p>“We wanted everyone to have an affordable option for securely protecting their Skycoin investment,” said a spokesperson for the project.</p><p>Unlike mobile or desktop software wallets, the seed phrase (or “private key”) that generates the Skycoin address on the Skywallet is never exposed to a computer or the Internet, and cannot be accessed or hijacked by an attacker.<strong>This means the Skywallet is completely private and secure</strong>, even if one’s personal computer or Internet connection is compromised.</p><p>The security of the Skywallet software may be verified by anyone who wishes to audit the code, because the complete codebase for the firmware is hosted in an open-source repository on <a href="https://github.com/skycoin/hardware-wallet" rel="noopener noreferrer" target="_blank">GitHub</a>.</p><p>The Skycoin team is uniquely qualified to produce Skywallets, as they have nearly a decade of experience building both hardware and software solutions to some of blockchain’s most intractable problems. Skycoin’s existing hardware products include approximately 10,000 Skyminer nodes deployed around the world, forming the telecommunications infrastructure of Skycoin’s new encrypted internet: Skywire.</p><p>More exciting hardware projects, including Skywire antennas and the next generation of Skyminers, will be announced in the coming weeks and months.</p><p>The Skywallet is available to order online at &nbsp; <a href="https://store.skycoin.com/" rel="noopener noreferrer" target="_blank">store.skycoin.com</a> beginning November 28, 2019.</p><p>Media who wish to schedule interviews may reach out to:&nbsp;</p><p>Tiffany</p><p> <a href="mailto:mktcn@skycoin.com">mktcn@skycoin.com</a></p><p>0085263533831</p><p> <br></p><hr><p> <br></p><p><strong>About Skycoin:</strong></p><p>Skycoin is bringing people what they want: a truly decentralized network without any central authority. Founded in 2011 by early developers of Bitcoin and Ethereum, Skycoin quickly grew into an ecosystem of exciting and ambitious projects, including <strong>Skywire</strong>, the new decentralized Internet; <strong>CX</strong>, a revolutionary fully-featured blockchain application programming language; and the cryptocurrency itself, <strong>Skycoin</strong> — simple to use, with virtually-free transactions that execute almost instantly.</p><p>In 2020, Skycoin will release a superior "web-of-trust" blockchain consensus algorithm called <strong>Obelisk</strong>, which solves the problems inherent to "proof-of-work" and "proof-of-stake" protocols, both of which are slowing down and compromising the integrity of other major cryptocurrencies.</p><p>For more background, please visit <a href="https://www.skycoin.com" rel="noopener noreferrer" target="_blank">https://www.skycoin.com</a></p>',
      },
    },
  },
  sky_wallet: {
    title: 'Skywallet - Skycoin`s New Hardware Wallet',
    description: 'Skywallet - New Hardware Wallet',
    about: {
      heading: 'Skywallet',
      subheading: 'Skycoin`s New Hardware Wallet',
      paragraph: 'When you store or access your cryptocurrency, you are your own bank, so the process should be simple and intuitive. Your hardware wallet is your bank vault and it should feel like a premium and secure device. We’ve spent months iterating over designs and incorporating user feedback in order to make Skywallet the best hardware wallet experience on the market.',
    },
    features: {
      heading: 'Getting started',
      recoveryseed: {
        title: 'Recovery seed',
        text:
          'The recovery seed is a backup for your entire device. If your device is lost or damaged, you can recover your wallets using the seed phrase. It is generated on your device and only shown once. It should go without saying that if somebody finds your seed, they can easily clone your device. Do not store the seed or communicate it digitally. Support will never ask for your seed.',
      },
      instructions: {
        title: 'Instructions',
        text:
          'Before connecting to your computer, please ensure that you have the latest version of the skycoin desktop wallet installed available at skycoin.com/downloads. If it is already installed, simply plug your device into your computer and follow the instructions on screen.',
      },
      treatment: {
        title: 'Treatment',
        text:
          'Do not expose the wallet to extreme temperatures or elements. It is not waterproof, heat or acid resistant.',
      },
      download: {
        title: 'Download',
        text:
          '<p>Download the Skywallet user manual here:</p><p> <a href="https://s3-ap-southeast-1.amazonaws.com/downloads.skycoin.com/skywallet/Skywallet-User_Manuals_Draft_1_c.pdf" rel="noopener noreferrer" target="_blank">User Manual</a></p><p>Download the Desktop Wallet and the Skywallet Daemon here:</p><p> <a href="/fr/downloads/">https://skycoin.com/downloads/</a></p>',
      },
    },
    roadmap: 'CX Roadmap',
  },
  skywallethdk: {
    title: 'Skywallet HDK',
    description: 'Skywallet HDK - Make your favourite token compatible with Skywallet',
    about: {
      heading: 'Skywallet HDK',
      subheading: 'Make your favourite token compatible with Skywallet',
      paragraph: '<p>The Skywallet HDK (Hardware Development Kit) is the developer-friendly version of the Skywallet hardware that is intended to make it easy to create applications, or integrate other cryptocurrencies and tokens into the Skywallet.</p><p>There are several key differences between the Skywallet and the Skywallet HDK that make the HDK easier to use for developers. The Skywallet HDK:</p><ul> <li>Does not have a case around the circuit board</li><li>Is physically bigger than the small, sleek consumer-facing Skywallet</li><li>Features larger buttons that are easier to work with</li><li>Has a 6-pin socket for ST programmer</li><li>Does not have a pre-flashed bootloader</li></ul><p>The primary use of the Skywallet HDK is to build capability into Skywallet to support cryptocurrencies beyond Skycoin and Skycoin Coin Hours. The HDK may also be used to create additional programs that may run on Skywallet. If a developer wishes to use Skywallet as an authentication device, for instance, they can use the HDK to develop that functionality.</p><p>All new programs and token compatibilities which are developed on the Skywallet HDK can be submitted to Skycoin for review. If approved, your update will be pushed out to all current Skywallet holders who can opt-in to the new functionality.</p><p>If you would like to extend the functionality and capability of Skywallet for all its users, grab a Skywallet HDK and get coding!</p>',
    },
    features: {
      heading: 'Getting started',
      instructions: {
        title: 'Instructions',
        text: '<p>Join the Telegram room <a href="https://t.me/SkycoinDevelopers" rel="noopener noreferrer" target="_blank">&commat;SkycoinDevelopers</a> or file an issue on Github if you want to get in touch with the development team.</p>',
      },
      treatment: {
        title: 'Treatment',
        text:
          'Do not expose the wallet to extreme temperatures or elements. It is not waterproof, heat or acid resistant.',
      },
      download: {
        title: 'Download',
        text:
          '<ul> <li> <a href="https://github.com/skycoin/hardware-wallet" rel="noreferrer nofollow" target="_blank">https://github.com/skycoin/hardware-wallet</a> </li><li> <a href="https://github.com/skycoin/hardware-wallet-daemon" rel="noreferrer nofollow" target="_blank">https://github.com/skycoin/hardware-wallet-daemon</a> </li><li> <a href="https://github.com/skycoin/hardware-wallet-go" rel="noreferrer nofollow" target="_blank">https://github.com/skycoin/hardware-wallet-go</a> </li></ul>',
      },
      documentation: {
        title: 'Documentation and codebase',
        text:
          '<ul> <li> <a href="https://github.com/skycoin/User-Manuals/tree/master/Skywallet" rel="noopener noreferrer" target="_blank">https://github.com/skycoin/User-Manuals/tree/master/Skywallet</a> </li><li> <a href="https://github.com/skycoin/hardware-wallet" rel="noopener noreferrer" target="_blank">https://github.com/skycoin/hardware-wallet</a> </li><li> <a href="https://github.com/skycoin/hardware-wallet-daemon" rel="noopener noreferrer" target="_blank">https://github.com/skycoin/hardware-wallet-daemon</a> </li><li> <a href="https://github.com/skycoin/hardware-wallet-go" rel="noopener noreferrer" target="_blank">https://github.com/skycoin/hardware-wallet-go</a> </li></ul>',
      },
    },
    gallery: {
      title: 'Gallery',
      description: 'Gallery',
      heading: 'Gallery',
      skywallethdk: {
        heading: 'Gallery',
      },
    },
  },
  cxchains: {
    title: 'CX Chains Overview',
  },
};

/* eslint-enable max-len */



// WEBPACK FOOTER //
// ./src/locales/fr.js